"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function get(target, property, receiver) {
            var base = _super_prop_base(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver || target);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _get_prototype_of(object);
        if (object === null) break;
    }
    return object;
}
function _to_array(arr) {
    return _array_with_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_rest();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && (typeof from === "undefined" ? "undefined" : _type_of(from)) === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return to;
};
var __toESM = function(mod, isNodeMode, target) {
    return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(// If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
        value: mod,
        enumerable: true
    }) : target, mod);
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// browser.ts
var browser_exports = {};
__export(browser_exports, {
    CookieStorage: function() {
        return CookieStorage;
    },
    SafeCookieStorage: function() {
        return SafeCookieStorage;
    },
    cookieStorage: function() {
        return cookieStorage;
    },
    locationWithQuery: function() {
        return locationWithQuery;
    },
    parseUrl: function() {
        return parseUrl;
    },
    referrer: function() {
        return referrer;
    },
    resolvePreviousPage: function() {
        return resolvePreviousPage;
    }
});
module.exports = __toCommonJS(browser_exports);
// lib/resolvers/browser/previousPage.ts
var import_path = __toESM(require("@tinkoff/utils/object/path"));
// lib/utils/advanced/is-external-navigation.ts
function isExternalNavigation(currentLocationHostname, referrerHostname) {
    var internalDomains = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    if (currentLocationHostname === referrerHostname) {
        return false;
    }
    return [
        currentLocationHostname,
        referrerHostname
    ].some(function(hostname) {
        return internalDomains.every(function(internalDomain) {
            return(// хост не является внутренним доменом и его саб-доменом
            hostname !== internalDomain && !hostname.endsWith(".".concat(internalDomain)));
        });
    });
}
// lib/utils/advanced/url.ts
function parseQuery(source) {
    var sepA = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "&", sepB = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "=";
    var result = {};
    var splitted = source.split(sepA);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = splitted[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            var _String_split = _to_array(String(entry).split(sepB)), key = _String_split[0], parts = _String_split.slice(1);
            if (key) {
                var value = parts.join(sepB);
                try {
                    value = decodeURIComponent(value);
                } catch (e) {}
                result[decodeURIComponent(key)] = value;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result;
}
function removeQueryParams(href) {
    return href.split("?")[0];
}
// lib/definitions/global.ts
var g = function() {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
}();
var d = g.document;
var w = g.window;
var n = g.navigator;
var Xhr = g.XMLHttpRequest;
// lib/resolvers/browser/previousPage.ts
function resolvePreviousPage(deps) {
    var referrer2 = deps.referrer, currentLocation = deps.location, internalDomains = deps.internalDomains;
    var isPageReloaded = (0, import_path.default)([
        "performance",
        "navigation",
        "type"
    ], w) === 1;
    var referrerLocation = isPageReloaded ? currentLocation : referrer2;
    if (!referrerLocation) {
        return;
    }
    var referrerLocationHostname = referrerLocation.hostname;
    var currentLocationHostname = currentLocation.hostname;
    if (isExternalNavigation(currentLocationHostname, referrerLocationHostname, internalDomains)) {
        return;
    }
    return removeQueryParams(referrerLocation.href);
}
// lib/services/browser/storages/cookie.ts
var import_toPairs = __toESM(require("@tinkoff/utils/object/toPairs"));
// lib/services/shared/cookies/checkCookieLimit.ts
function checkCookieLimit(limits, name, rawValue) {
    var value = encodeURIComponent(rawValue);
    var limit = limits[name] || limits.default;
    if (value.length > limit) {
        throw new Error("ECookieTooLarge: cookie ".concat(name, " exceeds maximum length of ").concat(limit, " bytes"));
    }
}
// lib/definitions/constants.ts
var SIXTY_DAYS = 60 * 24 * 60 * 60;
var consentCategories = {
    Essential: 1 /* Essential */ ,
    Functionality: 2 /* Functionality */ ,
    Statistics: 4 /* Statistics */ ,
    Marketing: 8 /* Marketing */ ,
    PersonalDataProcessing: 16 /* PersonalDataProcessing */ 
};
// lib/definitions/cookieList.ts
var utmExpire = SIXTY_DAYS;
var utmCookiesCategory = 8 /* Marketing */  | 4 /* Statistics */ ;
var utmCookies = {
    utmSource: {
        name: "utm_source",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    utmContent: {
        name: "utm_content",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    utmCampaign: {
        name: "utm_campaign",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    utmMedium: {
        name: "utm_medium",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    utmTerm: {
        name: "utm_term",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    utmDateSet: {
        name: "utm_date_set",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    sid: {
        name: "sid",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    wm: {
        name: "wm",
        category: utmCookiesCategory,
        expires: utmExpire,
        subdomains: true
    },
    visitorNewOrReturn: {
        name: "s_nr",
        category: utmCookiesCategory,
        expires: 365 * 24 * 60 * 60,
        // 365 days in seconds
        subdomains: true
    }
};
// lib/definitions/cookies-limits.ts
var UTM_SOURCE_LIMIT = 255;
var _obj;
var utmCookiesLimits = (_obj = {}, // group="platform_nginx" upstream_name:"*.pfp-prod.v2.prod.k8s.tcsbank.ru"  status:200 request_method:"GET"  | rex  field=query_string r"(utm_term\=(?<utm_field>[^&]+))"  | where utm_field != null | eval utm_len=len(utm_field) | top limit=25 utm_len
// синхронизируй в utmMarkers.md!
_define_property(_obj, utmCookies.utmSource.name, UTM_SOURCE_LIMIT), _define_property(_obj, "session_utm_source", UTM_SOURCE_LIMIT), _define_property(_obj, utmCookies.utmTerm.name, 600), _define_property(_obj, utmCookies.utmContent.name, 600), _define_property(_obj, utmCookies.utmCampaign.name, 255), _define_property(_obj, utmCookies.utmMedium.name, 255), _define_property(_obj, utmCookies.sid.name, 140), _define_property(_obj, utmCookies.wm.name, 100), _obj);
var cookiesLimits = _object_spread_props(_object_spread({}, utmCookiesLimits), {
    default: 72
});
// lib/utils/advanced/domain.ts
var reIpWithDots = /^(?:::(?:ffff:(0:)?)?)?(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
var reIpv4Embedded = /^([0-9a-fA-F]{1,4}:){1,4}:(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;
function isIpWithDots(host) {
    return reIpWithDots.test(host) || reIpv4Embedded.test(host);
}
function extractDomain(hostname) {
    if (isIpWithDots(hostname)) {
        return hostname;
    }
    return hostname.indexOf("localhost") >= 0 ? "localhost" : ".".concat(hostname.split(".").slice(-2).join("."));
}
// lib/services/browser/storages/cookie.ts
var CookieStorage = /*#__PURE__*/ function() {
    function CookieStorage(limits, logger) {
        _class_call_check(this, CookieStorage);
        this.limits = limits;
        this.logger = logger;
        this.isCookieAvailable = null;
        this.hasSamesiteNoneSupport = null;
        this.localState = /* @__PURE__ */ Object.create(null);
    }
    _create_class(CookieStorage, [
        {
            key: "get",
            value: function get(name) {
                if (this.checkCookieAvailability()) {
                    return this.getCookie(name);
                }
                return this.getLocalState(name);
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                if (this.checkCookieAvailability()) {
                    return this.getAllCookies();
                }
                return this.getAllLocalState();
            }
        },
        {
            key: "set",
            value: function set(name, value, exp, subdomains) {
                if (this.checkCookieAvailability()) {
                    this.setCookie(name, value, exp, subdomains);
                }
                this.setLocalState(name, value);
            }
        },
        {
            key: "remove",
            value: function remove(name, subdomains) {
                if (this.checkCookieAvailability()) {
                    this.removeCookie(name, subdomains);
                } else {
                    this.removeLocalState(name);
                }
            }
        },
        {
            // проверяет, доступны ли куки
            key: "checkCookieAvailability",
            value: function checkCookieAvailability() {
                if (this.isCookieAvailable != null) {
                    return this.isCookieAvailable;
                }
                if (d.cookie == null) {
                    this.isCookieAvailable = false;
                    return this.isCookieAvailable;
                }
                var cookieName = "test_cookie_sqJPwCiceI";
                d.cookie = "".concat(cookieName, "=true");
                var value = this.getCookie(cookieName);
                this.isCookieAvailable = value === "true";
                d.cookie = "".concat(cookieName, "=; expires=").concat(/* @__PURE__ */ new Date(0).toUTCString());
                return this.isCookieAvailable;
            }
        },
        {
            // проверяет, поддерживается ли установка кук с SameSite=None
            // https://www.chromium.org/updates/same-site/incompatible-clients/
            key: "checkSamesiteNoneSupport",
            value: function checkSamesiteNoneSupport() {
                if (this.hasSamesiteNoneSupport != null) {
                    return this.hasSamesiteNoneSupport;
                }
                if (!this.checkCookieAvailability()) {
                    this.hasSamesiteNoneSupport = false;
                    return this.hasSamesiteNoneSupport;
                }
                var cookieName = "test_cookie_yIKsyPp4Fh";
                d.cookie = "".concat(cookieName, "=true; samesite=none; secure");
                var value = this.getCookie(cookieName);
                this.hasSamesiteNoneSupport = value === "true";
                d.cookie = "".concat(cookieName, "=; expires=").concat(/* @__PURE__ */ new Date(0).toUTCString());
                return this.hasSamesiteNoneSupport;
            }
        },
        {
            key: "getCookie",
            value: function getCookie(name) {
                var rawValue = this.getRawCookie(name);
                return rawValue ? decodeURIComponent(rawValue) : null;
            }
        },
        {
            key: "getAllCookies",
            value: function getAllCookies() {
                var all = this.getAllRawCookies();
                return (0, import_toPairs.default)(all).reduce(function(acc, param) {
                    var _param = _sliced_to_array(param, 2), name = _param[0], value = _param[1];
                    acc[name] = decodeURIComponent(value);
                    return acc;
                }, {});
            }
        },
        {
            key: "setCookie",
            value: function setCookie(name, value) {
                var expires = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "session", subdomains = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
                try {
                    checkCookieLimit(this.limits, name, String(value));
                } catch (e) {
                    var _this_logger;
                    (_this_logger = this.logger) === null || _this_logger === void 0 ? void 0 : _this_logger.error(e);
                    return;
                }
                var attributes = [];
                attributes.push("".concat(name, "=").concat(encodeURIComponent(value)), "path=/", "domain=".concat(subdomains ? extractDomain(w.location.hostname) : w.location.hostname));
                if (expires !== "session") {
                    var expiryDate = expires === 0 ? /* @__PURE__ */ new Date(0) : new Date(Date.now() + expires * 1e3);
                    attributes.push("expires=".concat(expiryDate.toUTCString()));
                }
                if (this.checkSamesiteNoneSupport()) {
                    attributes.push("samesite=none", "secure");
                }
                d.cookie = attributes.join("; ");
            }
        },
        {
            key: "removeCookie",
            value: function removeCookie(name, subdomains) {
                if (this.getCookie(name) !== null) {
                    this.setCookie(name, "", 0, subdomains);
                }
            }
        },
        {
            key: "getLocalState",
            value: function getLocalState(name) {
                return this.localState[name] || null;
            }
        },
        {
            key: "getAllLocalState",
            value: function getAllLocalState() {
                return this.localState;
            }
        },
        {
            key: "setLocalState",
            value: function setLocalState(name, value) {
                this.localState[name] = value.toString();
                return value;
            }
        },
        {
            key: "removeLocalState",
            value: function removeLocalState(name) {
                if (name in this.localState) {
                    delete this.localState[name];
                }
            }
        },
        {
            key: "getRawCookie",
            value: function getRawCookie(name) {
                return d.cookie.split("; ").reduce(function(acc, v) {
                    var _v_split = _sliced_to_array(v.split("="), 2), key = _v_split[0], value = _v_split[1];
                    return key === name ? value : acc;
                }, "") || null;
            }
        },
        {
            key: "getAllRawCookies",
            value: function getAllRawCookies() {
                return d.cookie.split("; ").reduce(function(acc, pair) {
                    var _pair_split = _sliced_to_array(pair.split("="), 2), name = _pair_split[0], value = _pair_split[1];
                    if (!name) {
                        return acc;
                    }
                    acc[name] = value;
                    return acc;
                }, {});
            }
        }
    ]);
    return CookieStorage;
}();
var cookieStorage = new CookieStorage(cookiesLimits);
// lib/services/browser/storages/safe-cookie.ts
var SafeCookieStorage = /*#__PURE__*/ function(CookieStorage) {
    _inherits(SafeCookieStorage, CookieStorage);
    function SafeCookieStorage() {
        _class_call_check(this, SafeCookieStorage);
        return _call_super(this, SafeCookieStorage, arguments);
    }
    _create_class(SafeCookieStorage, [
        {
            key: "get",
            value: function get(name) {
                try {
                    return _get(_get_prototype_of(SafeCookieStorage.prototype), "get", this).call(this, name);
                } catch (e) {
                    return _get(_get_prototype_of(SafeCookieStorage.prototype), "getRawCookie", this).call(this, name);
                }
            }
        },
        {
            key: "getAll",
            value: function getAll() {
                try {
                    return _get(_get_prototype_of(SafeCookieStorage.prototype), "getAll", this).call(this);
                } catch (e) {
                    return _get(_get_prototype_of(SafeCookieStorage.prototype), "getAllRawCookies", this).call(this);
                }
            }
        }
    ]);
    return SafeCookieStorage;
}(CookieStorage);
var safeCookieStorage = new SafeCookieStorage(cookiesLimits);
// lib/services/browser/locationWithQuery.ts
function locationWithQuery() {
    var location = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : d.location;
    var loc = {
        get query () {
            return parseQuery(location.search.slice(1));
        },
        get pathname () {
            if (location.pathname.charAt(0) !== "/") {
                return "/".concat(location.pathname);
            }
            return location.pathname;
        }
    };
    var locationKeys = [
        "hash",
        "host",
        "hostname",
        "href",
        "port",
        "protocol",
        "search",
        "origin"
    ];
    locationKeys.forEach(function(prop) {
        Object.defineProperty(loc, prop, {
            get: function get() {
                return location[prop];
            },
            set: function set(v) {
                if (prop !== "origin") {
                    location[prop] = v;
                }
            },
            enumerable: true
        });
    });
    return loc;
}
// lib/services/browser/parseUrl.ts
function parseUrl(href) {
    var l = d.createElement("a");
    l.href = href;
    return locationWithQuery(l);
}
// lib/services/browser/referrer.ts
function referrer() {
    return d.referrer ? parseUrl(d.referrer) : void 0;
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
    CookieStorage: CookieStorage,
    SafeCookieStorage: SafeCookieStorage,
    cookieStorage: cookieStorage,
    locationWithQuery: locationWithQuery,
    parseUrl: parseUrl,
    referrer: referrer,
    resolvePreviousPage: resolvePreviousPage
});
//# sourceMappingURL=index.js.map